export default {
  NAVIGATION: 'navigation',
  RANDOM_FLOW: 'random_flow',
  PAUSE: 'pause',
  SAY: 'say',
  WEBSITE: 'website',
  HOME: 'home',
  API_CALL: 'api_call',
  SET_VARIABLE: 'set_variable',
  RESET_VARIABLE: 'reset_variable',
  CONDITION: 'eval_condition',
  QR_READER: 'qr_reader',
  ROBOT_COMMAND: 'robot_command',
  R2R_CHAT: 'robot_chat',
  ROBOT_ACTION: 'robot_action',
  CHANGE_LANGUAGE: 'change_language',
  CUSTOM_SCRIPT: 'custom_script',
  RESET_KNOWLEDGE_BASE: 'reset_knowledge_base',
  KNOWLEDGE_BASE: 'knowledge_base',
};
